import {
  SET_LOADING_DATA,
  SET_LOADING_RECOMMENDATION,
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  GET_RECOMMENDATION_REQUEST,
  GET_RECOMMENDATION_SUCCESS
} from './sales-tracking-constants';

export const setLoadingData = (loading: boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingRecommendation = (loading: boolean) => {
  return {
    type: SET_LOADING_RECOMMENDATION,
    loading
  };
};

export const getAllRequest = () => {
  return {
    type: GET_ALL_REQUEST
  };
};

export const getAllSuccess = (payload: any) => {
  return {
    type: GET_ALL_SUCCESS,
    payload
  };
};

export const getRecommendationRequest = payload => {
  return {
    type: GET_RECOMMENDATION_REQUEST,
    payload
  };
};

export const getRecommendationSuccess = (payload: any) => {
  return {
    type: GET_RECOMMENDATION_SUCCESS,
    payload
  };
};
